import { IEntries } from "./index";

export function mapAvailableEmailDomains(entries: IEntries) {
  const emailDomains: any = entries.valueList.ordered.find(
    f => f.fields.name[process.env.REACT_APP_DEFAULT_LANG] === "emailDomains"
  );
  const emails = emailDomains ? emailDomains.fields.values[process.env.REACT_APP_DEFAULT_LANG] : [];

  return {
    emailDomains: emails[0].fields.contentLong[process.env.REACT_APP_DEFAULT_LANG]
  };
}
